// removed by extract-text-webpack-plugin
module.exports = {"LieferscheinDownloader":"LieferscheinDownloader__39QjI"};